import {SxProps, Theme} from '@mui/material';
import theme from 'src/theme';

export const popoverSx: SxProps<Theme> = {
    '& .MuiPaper-root': {
        maxWidth: theme.spacing(200 / 8),
        width: '100%',
        p: 1,
    },
};
export const menuContentSx: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
};
export const menuBtnSx: SxProps<Theme> = {
    width: '100%',
};
export const menuBtnTextSx: SxProps<Theme> = {
    width: '100%',
    textAlign: 'start',
    fontSize: theme.spacing(14 / 8),
    fontWeight: 400,
    color: theme.palette.neutral[400],
};
